module.exports = __webpack_public_path__ + "assets/ic_tree08.e78bd6d6.svg";